export default __webpack_public_path__ + "static/media/document_blue.76789d7f.svg";